import { createSelector } from 'reselect';

export const getProjectsAll = ({ projects }) => projects.all.data;

export const getIsLoadingAll = ({ projects }) => projects.all.isLoading;

export const getProjectsList = ({ projects }) => projects.list.data.items;

export const getProjectsListCount = ({ projects }) => projects.list.data.count;

export const getIsLoadingList = ({ projects }) => projects.list.isLoading;

export const getIsGrid = ({ projects }) => projects.list.isGrid;

export const getSortOptions = ({ projects }) => projects.list.sortOptions;

export const getPaginationOptions = ({ projects }) =>
  projects.list.paginationOptions;

export const getFilteredSortOptions = createSelector(
  getSortOptions,
  getPaginationOptions,
  (sortOptions, paginationOptions) =>
    sortOptions.map(option => ({
      ...option,
      selected: option.value === paginationOptions.ordering,
    })),
);

export const getSelectedSortOption = createSelector(
  getFilteredSortOptions,
  options => options.find(option => option.selected === true),
);

export const getIsAdding = ({ projects }) => projects.add.isLoading;

export const getProjectsWithNamesConcatedWithAccount = ({ projects }) =>
  projects.all.data.map(project => ({
    ...project,
    name: `${project.name} (${project.account})`,
  }));
